import React from "react"
import { Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"

const LongHeaderAndInput = (props) => (
  <>
    <Body color="black-80">
      {props.header} {props.required ? <span>*</span> : ""}
      {props.explanationOnClick ? (
        <a
          className="ml1 underline carrot-orange hover-black animate-all"
          href="#/"
          onClick={props.explanationOnClick}
          data-testid={props.testId}
        >
          <img className="di v-tbtp" alt="help" src="/images/icn-help.svg" />
        </a>
      ) : (
        ""
      )}
    </Body>
    <Spacer height={0.5} />
  </>
)

export { LongHeaderAndInput }
